import { useState } from "react";

export const permissionsList = [
    "Dashboard Access",
    "View Raw Inventory",
    "View Repaired Inventory",
    "View Main Inventory",
    "Add Main Inventory",
    "Add Repaired Inventory",
    "Add Raw Inventory",
    "Manage Roles",
    "Create Users",
    "Create Departments",
    "Billing",
    "Search Product",
    "View Transactions",
  ];
